import _ from 'lodash'
import React from 'react'
import ChartCard from 'components/CleanComponents/ChartCard'
import InfoCard from 'components/CleanComponents/InfoCard'
import { Button, Input, Icon, Table, DatePicker, Radio, Tabs, Select } from 'antd'
import ChartistGraph from 'react-chartist'
import Chartist from 'chartist'
import moment from 'moment'
import axios from 'axios';
import { connect } from 'react-redux'
import { FormattedNumber, FormattedDate } from 'react-intl'
import { CSVLink } from 'react-csv'

import { fetchOverviewPage, setPublisherSelected } from 'reducers'


import PoxAPI from 'utils/api'


const TabPane = Tabs.TabPane
const { MonthPicker, RangePicker, WeekPicker } = DatePicker
const Option = Select.Option

const barData = {
  labels: [65, 59, 80, 81, 56, 55, 40, 100, 129, 100, 80, 130, 150, 200],
  datasets: [
    {
      label: 'Revenue',
      backgroundColor: '#3079b8',
      borderColor: '#3079b8',
      borderWidth: 1,
      data: [65, 59, 80, 81, 56, 55, 40, 100, 129, 100, 80, 130, 150, 200],
    },
  ],
}

const barOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
      },
    ],
    yAxes: [
      {
        stacked: true,
      },
    ],
  },
}

let ordersGraph

const columns = [
  {
    title: 'Date',
    dataIndex: 'timestamp',
    key: 'timestamp',
    render: value => <FormattedDate value={value} />
  },
  {
    title: 'Revenue',
    dataIndex: 'total_revenue',
    key: 'total_revenue',
    render: value => <FormattedNumber style="currency" currency="EUR" minimumFractionDigits={0} value={value}  />,
  },
  {
    title: 'Impressions',
    dataIndex: 'total_impressions',
    key: 'total_impressions',
    render: value => <FormattedNumber value={value} />,
  },
  {
    title: 'Clicks',
    dataIndex: 'total_clicks',
    key: 'total_clicks',
    render: value => <FormattedNumber value={value} />,
  },
  {
    title: 'CTR',
    dataIndex: 'ctr',
    key: 'ctr',
    render: value => <FormattedNumber style="percent" minimumFractionDigits={2} value={value} />,    
  },
  {
    title: 'eCPM',
    dataIndex: 'cpm',
    key: 'cpm',
    render: value => <FormattedNumber style="currency" currency="EUR" minimumFractionDigits={2} value={value}  />,    
  },
]


const mapStateToProps = (state, props) => ({
  reviveState: state.get('app').get('reviveState').toJS(),
})

@connect(mapStateToProps)
class Overview extends React.Component {
  state = {
      reviveState: this.props.reviveState,
      tableData: [],
      csvData: [],
      chart_data: {
        impressions: {},
        clicks: {},
        revenue: {},
        cpm: {},
        ctr: {}
      },
      startDate: null,
      endDate: null
  }

  componentWillReceiveProps(nextProps) {
    console.log('componentWillReceiveProps', nextProps)
    this.setState({reviveState: nextProps.reviveState})
    this.generateChartData(nextProps)
  }

  componentWillMount() {
    this.loadData()
  }

  componentDidMount() {

    this.generateChartData(this.props)
  }

  componentDidUpdate() {
    //this.generateChartData()
    //console.log(this.props.reviveState.totals['revenue'])
  }


  async loadData(payload = {startDate: this.state.reviveState.startDate, endDate: this.state.reviveState.endDate, publisherIds: JSON.parse(window.localStorage.getItem('publisher_selected')) || []}) {
    const { dispatch } = this.props
    dispatch(fetchOverviewPage(payload))
  }

  generateChartData(data) {

    let chart_data = {}
    const types = Object.keys(data.reviveState.charts)

    types.forEach(ctype => {

      chart_data[ctype] = {
        series: [
          data.reviveState.charts[ctype]
        ],
        axisX: {
          type: Chartist.FixedScaleAxis,
          divisor: 5,
          labelInterpolationFnc: function(value) {
            return moment(value).format('MMM D')
          },
        },
      }
    })

    const tableData = _.toArray(data.reviveState.rawData)
    tableData.sort(function(a, b) {
      return b.timestamp - a.timestamp;
    })

    let csvData = [['Date', 'Impressions', 'Clicks', 'CTR', 'Revenue', 'CPM']]

    tableData.map(item => {


      csvData.push([moment(item.timestamp).format('YYYY-MM-DD'), item.total_impressions, item.total_clicks, item.ctr, item.total_revenue, item.cpm])

    })


    this.setState({ chart_data, tableData, csvData })

  }

  onDateChange(dates) {
    this.loadData({startDate: dates[0], endDate: dates[1], publisherIds: this.state.reviveState.publisher_selected})
  }

  onPublisherChange(selected) {
    this.loadData({startDate: this.state.reviveState.startDate, endDate: this.state.reviveState.endDate, publisherIds: selected})

  }

  


  render() {
    const chartistOptions = {
      fullWidth: true,
      fullHeight: true,
      showArea: true,
      chartPadding: {
        right: 30,
        left: 0,
      },
      plugins: [
        Chartist.plugins.tooltip({
          transformTooltipTextFnc: (value) => {
            return Number(value.split(',')[1]).toFixed(2)
          }
        })
      ],
      axisX: {
        type: Chartist.FixedScaleAxis,
        divisor: 5,
        labelInterpolationFnc: function(value) {
          return moment(value).format('MMM D')
        },
      },
    }

    const datePicker = (
        <RangePicker
          size="large"
          className="mt-3"
          defaultValue={ [this.state.reviveState.startDate, this.state.reviveState.endDate] }
          ranges={{
            'Last 7 Days': [moment().subtract(7, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
          }}
          onChange={this.onDateChange.bind(this)}
        />
    )

    let PubOptions = []

    const publisher_desc = Object.entries(this.state.reviveState.publisher_desc)
    publisher_desc.map(entry => {
      let id = parseInt(entry[0])
      PubOptions.push(<Option value={id}>{entry[1].name}</Option>)
    })

    console.log('PubOptions', PubOptions)


    if (!this.state.reviveState.summary) {
      return (
        <div>
          Loading ...
        </div>
      )
    }

    return (
      <div>
        <div className="utils__title utils__title--flat mb-3">
          <span className="text-uppercase font-size-16">Revenue</span>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <ChartCard
              title={'Today'}
              amount={<FormattedNumber style="currency" currency="EUR" minimumFractionDigits={0} value={this.state.reviveState.summary.revenue_today || 0}  />}
              />
          </div>
          <div className="col-lg-3">
            <ChartCard
              title={'Yesterday'}
              amount={<FormattedNumber style="currency" currency="EUR" minimumFractionDigits={0} value={this.state.reviveState.summary.revenue_yesterday || 0}  />}
              />
          </div>
          <div className="col-lg-3">
            <ChartCard
              title={'This Week'}
              amount={<FormattedNumber style="currency" currency="EUR" minimumFractionDigits={0} value={this.state.reviveState.summary.revenue_week || 0}  />}
            />
          </div>
          <div className="col-lg-3">
            <ChartCard
              title={'This Month'}
              amount={<FormattedNumber style="currency" currency="EUR" minimumFractionDigits={0} value={this.state.reviveState.summary.revenue_month || 0}  />}
             />
          </div>
        </div>

        <div className="utils__title utils__title--flat mb-3">
          <div className="pull-right" />
          <div className="utils__title">
            <span className="text-uppercase font-size-16">Overview 

            </span>
          </div>
        </div>

        <div className="card">
          <div className="card-body" style={{ paddingTop: '5px' }}>
            <Tabs
              defaultActiveKey="1"
              tabBarStyle={{ marginBottom: 0 }}
              tabBarExtraContent={ datePicker }
            >

              <TabPane
                tab={
                  <span>
                    <span>Revenue</span>
                    <h3>
                      <strong> <FormattedNumber style="currency" currency="EUR" minimumFractionDigits={0} value={this.state.reviveState.totals['revenue'] || 0} /></strong>
                    </h3>
                  </span>
                }
                key="1"
              >

                <ChartistGraph
                  data={this.state.chart_data['revenue']}
                  options={chartistOptions}
                  className="chart-area mt-4 chartist ct-major-twelfth "
                  type="Line"
                />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <span>Ad Impressions</span>
                    <h3>
                      <strong><FormattedNumber value={this.state.reviveState.totals['impressions'] || 0} /></strong>
                    </h3>
                  </span>
                }
                key="2"
              >
                <ChartistGraph
                  data={this.state.chart_data['impressions']}
                  options={chartistOptions}
                  className="chart-area mt-4 chartist ct-major-twelfth "
                  type="Line"
                />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <span>Clicks</span>
                    <h3>
                      <strong><FormattedNumber value={this.state.reviveState.totals['clicks'] || 0} /></strong>
                    </h3>
                  </span>
                }
                key="3"
              >
                <ChartistGraph
                  data={this.state.chart_data['clicks']}
                  options={chartistOptions}
                  className="chart-area mt-4 chartist ct-major-twelfth "
                  type="Line"
                />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <span>CTR</span>
                    <h3>
                      <strong><FormattedNumber style="percent" minimumFractionDigits={2} value={this.state.reviveState.totals['ctr'] || 0} /></strong>
                    </h3>
                  </span>
                }
                key="4"
              >
                <ChartistGraph
                  data={this.state.chart_data['ctr']}
                  options={chartistOptions}
                  className="chart-area mt-4 chartist ct-major-twelfth "
                  type="Line"
                />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <span>eCPM</span>
                    <h3>
                      <strong><FormattedNumber style="currency" currency="EUR" minimumFractionDigits={2} value={this.state.reviveState.totals['cpm'] || 0}  /></strong>
                    </h3>
                  </span>
                }
                key="5"
              >
                <ChartistGraph
                  data={this.state.chart_data['cpm']}
                  options={chartistOptions}
                  className="chart-area mt-4 chartist ct-major-twelfth "
                  type="Line"
                />
              </TabPane>
            </Tabs>


            <div className="row">
              <div className="col-lg-12">

                <Select
                  mode="multiple"
                  size="default"
                  placeholder="Please select"
                  style={{ minWidth: 200 }}
                  onChange={this.onPublisherChange.bind(this)}
                  value={this.props.reviveState.publisher_selected}>
    
                  {PubOptions}

              </Select>

              </div>
            </div>


          </div>
        </div>

        <div className="utils__title utils__title--flat mb-3">
          <div className="pull-right" />
          <div className="utils__title">
            <span className="text-uppercase font-size-16">Details</span>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <Table 
              dataSource={this.state.tableData} 
              columns={columns} 
              rowKey="timestamp" 
              bordered={true} 
              size="middle" 
              pagination={{ pageSizeOptions: ['14', '30', '90'], showSizeChanger: true, pageSize: 14 }}
              footer={() => {
                return <CSVLink data={this.state.csvData} filename={"PoxExport.csv"}><i className="icmn-download"></i> Download CSV</CSVLink>
              }} />
            
          </div>
        </div>
      </div>
    )
  }
}

export default Overview



// WEBPACK FOOTER //
// ./src/containers/OverviewPage/Overview/index.js